<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div class="box" v-else>
      <div class="head">
        <img class="img" :src="datas.product.img" />
        <h5 class="name">{{datas.product.name}}</h5>
      </div>
      
      <div class="body">
        <ul>
          <li>产品名称：{{ datas.product.name }}</li>
          <li>农药名称：{{ datas.product.alias_name }}</li>
          <li v-for="(item, index) in datas.product.attribute" v-if="index < 2" :key="index">
            <p class="label">{{item.key}}：{{item.value}}</p>
          </li>
          <li v-if="datas.product.unit">规格：{{ datas.product.unit }}</li>
          <li>农药登记证号：{{ datas.product.reg_code_str }}</li>
          <li>登记证持有人：{{ datas.product.reg_code_owner }}</li>
          <li>单元识别代码：{{ code }}</li>
          <li @click="goDetail">追溯网址：sy.oid.plus<img class="icon" src="/static/images/right.png"></li>
          <li class="text-right">查询次数：<span>{{ datas.scan_count }}次</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import AlertMsg from '@/components/AlertMsg.vue'
import Form from '@/components/Form.vue'
import mixin from '../mixins/mixin.js'
export default {
  name: 'Pesticide06',
  components: {
    'K-Loading': Loading,
    'K-AlertMsg': AlertMsg,
    'K-Form': Form,
  },
  mixins: [mixin],
  data() {
    return {
      showDetail: false,
      tabs: {
        index: 0,
        list: [{
          tit: '溯源信息',
        },{
          tit: '公司简介'
        },{
          tit: '荣誉证书'
        }]
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    async initData(){
      //判断是演示还是真实码标
      if (this.$route.query.type == "demo") {
        const pid = this.$route.query.pid; //产品ID
        const rid = this.$route.query.rid; //企业ID
        this.GetDemoDatas(pid, rid);  //获取演示模板信息
      } else {
        await this.GetDatas();  //获取码标信息
        console.log(this.datas);
      }
    },
    goDetail(){
      localStorage.setItem("wwm_ref", JSON.stringify({ template: 'Pesticide08', data: this.datas }));
      this.$router.push({ path: "/Details" }); // 模板路由跳转
    }
  }
}
</script>

<style scoped lang="scss">
.box{
  font-family: auto;
}
.head{
  padding: 30px;
  background-color: #4a4a48;
  .img{
    width: 80px;
    height: 80px;
    margin: auto;
    display: table;
  }
  .name{
    color: white;
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
  }
}
.body{
  padding-left: 20px;
  background-color: white;
  border-bottom: 1px solid #bbb;
  ul{
    li{
      color: #666;
      font-size: 14px;
      padding: 11px 0;
      position: relative;
      padding-right: 15px;
      .icon{
        position: absolute;
        width: 20px;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    li:not(:last-child){
      border-bottom: 1px solid #bbb;
    }
    .text-right{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Pesticide08.vue